// extracted by mini-css-extract-plugin
export var border = "_2h-8";
export var brand = "_2h-t";
export var button = "_2h-l";
export var center = "_2h-a";
export var centered = "_2h-6";
export var closeButton = "_2h-c";
export var disabledWrapper = "_2h-m";
export var error = "_2h-p";
export var extraLarge = "_2h-4";
export var extraSmall = "_2h-1";
export var fill = "_2h-i";
export var footer = "_2h-h";
export var footerAction = "_2h-j";
export var footerButtons = "_2h-k";
export var header = "_2h-7";
export var headerWithClose = "_2h-d";
export var icon = "_2h-o";
export var info = "_2h-s";
export var inline = "_2h-9";
export var large = "_2h-3";
export var main = "_2h-e";
export var modal = "_2h-0";
export var nearFull = "_2h-5";
export var neutral = "_2h-u";
export var noPadding = "_2h-g";
export var none = "_2h-v";
export var scrollable = "_2h-f";
export var small = "_2h-2";
export var success = "_2h-r";
export var tight = "_2h-n";
export var titleIcon = "_2h-b";
export var warn = "_2h-q";